import { floor } from 'lodash'

export function quizScoreDisplay(score: number, precision: number) {
  return floor(score, precision)
}
